<template>
  <div>
    <div class="mdfeFormCard">
      <el-form ref="step3" :model="selectedTagForm" label-position="top">
        <el-card>
          <el-form-item :label="$t('mdfeTranslate.AbnormalMdfe')">
            <el-input v-model="mdfeKey" :placeholder="$t('placeOrder.pleaseInput')" />
          </el-form-item>
        </el-card>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold;">{{ $t('mdfeTranslate.DriverAndVehicle') }}</span>
          </div>
          <div>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item
                  :label="$t('collectionCenter.driver1')"
                  prop="selectedDriver"
                  :rules="{
                    required: true,
                    message: $t('GlobalSetObj.pleaseChoose'),
                    trigger: ['blur', 'change']
                  }"
                >
                  <el-select
                    v-model="selectedTagForm.selectedDriver"
                    :placeholder="$t('placeOrder.pleaseChoose')"
                    class="formTable"
                    clearable
                    filterable
                    remote
                    reserve-keyword
                    :remote-method="getDriverInfo"
                    style="width: 100%"
                    @visible-change="handleDriverInfo"
                  >
                    <el-option
                      v-for="item in driverList"
                      :key="item.id"
                      :label="item.driverName"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$t('collectionCenter.licensePlateNumber')"
                  prop="vehiclePlate"
                  :rules="{
                    required: selectedTagForm.selectedDriverItem.length === 0,
                    message: $t('collectionCenter.notNull'),
                    trigger: ['change']
                  }"
                >
                  <el-input
                    v-model="selectedTagForm.vehiclePlate"
                    :placeholder="$t('placeOrder.pleaseInput')"
                    clearable
                    style="width: 100%"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div style="display: flex">
              <div style="flex: 1; padding-right: 5px">
                <el-button
                  size="small"
                  type="primary"
                  style="width: 100%"
                  @click="addDriver"
                >
                  {{ $t('mdfeTranslate.ChooseVehicleAndDriver') }}
                </el-button>
              </div>
              <div style="flex: 1;padding-left: 5px">
                <el-button
                  size="small" type="danger" style="width: 100%"
                  @click="deleteAllDriver"
                >
                  {{ $t('mdfeTranslate.DeleteAll') }}
                </el-button>
              </div>
            </div>
            <div style="margin-top: 10px">
              <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('mdfeTranslate.SelectedDriver') }}</div>
            </div>
            <div v-if="selectedTagForm.selectedDriverItem.length > 0" :key="selectedTagFormKey" style="display: flex;">
              <div style="flex: 1;padding: 10px;border: 1px solid #ccc;border-radius: 5px;margin-right: 10px;height: 300px;overflow-y: auto">
                <div
                  v-for="(item, index) in selectedTagForm.selectedDriverItem"
                  :key="index"
                  style="margin-bottom: 10px;"
                >
                  <div v-if="index === 0" style="color: black;font-weight: bold;height: 50px;">
                    {{ item.name }}
                  </div>
                  <div style="display: flex;border: 1px solid #ccc;border-radius: 5px;padding: 6px;">
                    <div style="flex: 1;">
                      <!--姓名-->
                      <div>{{ $t('collectionCenter.compellation') }}: {{ item.name }}</div>
                      <!--税号-->
                      <div>{{ $t('mdfeTranslate.document') }}(CPF/CNPJ): {{ item.cpf }}</div>
                    </div>
                    <div style="width: 50px">
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleteDriver(index)"
                      >
                        <i class="el-icon-delete" />
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div style="flex: 1;padding: 10px;border: 1px solid #ccc;border-radius: 5px;margin-left: 10px">
                <div>
                  <div style="color: black;font-weight: bold;height: 50px;">{{ vehicleInformation.licensePlateNumber }}</div>
                  <!--车牌-->
                  <div>{{ $t('GlobalSetObj.licensePlateNumber') }}: {{ vehicleInformation.licensePlateNumber }}</div>
                  <!--卡车租赁-->
                  <div>{{ $t('mdfeTranslate.TrailerRENAVAM') }}: {{ vehicleInformation.TrailerRENAVAM }}</div>
                  <!--卡车皮重-->
                  <div>{{ $t('mdfeTranslate.TrailerTare') }}: {{ vehicleInformation.TrailerTare }}</div>
                  <!--卡车容量-->
                  <div>{{ $t('mdfeTranslate.TrailerCapacity') }}: {{ vehicleInformation.TrailerCapacity }}</div>
                  <!--卡车RNTRC-->
                  <div>{{ $t('mdfeTranslate.TrailerRNTRC') }}: {{ vehicleInformation.TrailerRNTRC }}</div>
                  <!--货车证件-->
                  <div>{{ $t('mdfeTranslate.TruckDocuments') }}: {{ vehicleInformation.TrailerDocuments }}</div>
                  <div>IE: {{ vehicleInformation.ie }}</div>
                  <!--州-->
                  <div>{{ $t('mdfeTranslate.State') }}: {{ vehicleInformation.State }}</div>
                  <!--车轮类型-->
                  <div>{{ $t('mdfeTranslate.WheelKind') }}: {{ vehicleInformation.WheelKind }}</div>
                  <!--车辆类型-->
                  <div>{{ $t('mdfeTranslate.VehicleType') }}: {{ vehicleInformation.vehicleType }}</div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-form>
      <el-card class="box-card">
        <el-form ref="step4" :model="selectedTagForm" label-position="top">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item
                :label="$t('mdfeTranslate.TrailerPlateNumber')"
                prop="veicReboque"
                class="appendTag"
              >
                <el-input v-model.trim="selectedTagForm.veicReboque" :placeholder="$t('placeOrder.pleaseInput')" style="width: 500px;">
                  <template slot="append">
                    <i class="el-icon-circle-plus-outline" style="font-size: 26px" @click="addVeicReboque" />
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('mdfeTranslate.SelectedVehicles') }}</div>
        <div v-if="veicReboqueList.length > 0" class="driver-container">
          <div
            v-for="(item, index) in veicReboqueList"
            :key="index"
            class="driver-item"
            :class="getColSpan(index, veicReboqueList.length)"
          >
            <div style="color: black;font-weight: bold;height: 50px;">{{ item.licensePlateNumber }}
              <div style="float: right">
                <el-button
                  type="danger"
                  size="small"
                  @click="deleteVeicReboque(index)"
                >
                  <i class="el-icon-delete" />
                </el-button>
              </div>
            </div>
            <div>
              <!--车辆所属公司-->
              <div>{{ $t('mdfeTranslate.Proprietário') }}: {{ item.providerName }}</div>
              <!--车牌-->
              <div>{{ $t('GlobalSetObj.licensePlateNumber') }}: {{ item.licensePlateNumber }}</div>
              <!--税号-->
              <div>{{ $t('mdfeTranslate.document') }}(CPF/CNPJ): {{ item.driverDocument }}</div>
              <!--卡车租赁-->
              <div>{{ $t('mdfeTranslate.TrailerRENAVAM') }}: {{ item.TrailerRENAVAM }}</div>
              <!--卡车皮重-->
              <div>{{ $t('mdfeTranslate.TrailerTare') }}: {{ item.TrailerTare }}</div>
              <!--卡车容量-->
              <div>{{ $t('mdfeTranslate.TrailerCapacity') }}: {{ item.TrailerCapacity }}</div>
              <!--卡车RNTRC-->
              <div>{{ $t('mdfeTranslate.TrailerRNTRC') }}: {{ item.TrailerRNTRC }}</div>
              <div>IE: {{ item.ie }}</div>
              <!--州-->
              <div>{{ $t('mdfeTranslate.State') }}: {{ item.State }}</div>
              <!--车辆类型-->
              <div>{{ $t('mdfeTranslate.VehicleType') }}: {{ item.vehicleType }}</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div style="margin-top: 10px;text-align: right;">
      <el-button
        type="primary"
        @click="submitAbnormal"
      >
        {{ $t('collectionCenter.Confirm') }}
      </el-button>
    </div>
  </div>
</template>
<script>
import {
  getCarInfoByPlateNumber,
  getDriverPage, handleMdfeException
} from '@/api/invoiceCenter';
export default {
  name: 'AbnormalMdfe',
  data() {
    return {
      mdfeKey: '',
      selectedTagForm: {
        selectedDriver: '',
        vehiclePlate: '',
        selectedDriverItem: []
      },
      driverList: [],
      selectedTagFormKey: new Date().getTime(),
      vehicleInformation: {
        driverDocument: '',
        licensePlateNumber: '',
        TrailerRENAVAM: '',
        TrailerTare: '',
        TrailerCapacity: '',
        TrailerRNTRC: '',
        TrailerDocuments: '',
        ie: '',
        State: '',
        WheelKind: '',
        vehicleType: ''
      },
      veicReboqueList: []
    };
  },
  methods: {
    // 获取司机信息
    getDriverInfo(driverName = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          driverName
        }
      };
      getDriverPage(param).then(res => {
        if (res.code === 200) {
          this.driverList = res.data.records;
        }
      });
    },
    handleDriverInfo(val) {
      if (val) {
        this.getDriverInfo();
      }
    },
    // 添加司机
    addDriver() {
      this.$refs.step3.validate(async valid => {
        if (valid) {
          let isAdd = true;
          if (this.selectedTagForm.selectedDriverItem && this.selectedTagForm.selectedDriverItem.length > 0) {
            this.selectedTagForm.selectedDriverItem.map(item => {
              if (item.id === this.selectedTagForm.selectedDriver) {
                isAdd = false;
              }
            });
          }
          if (!isAdd) {
            this.$message.error(this.$t('mdfeTranslate.SelectedDriverCannotBeTheSame'));
            return;
          }
          let isPlateNumber = true;
          if (this.selectedTagForm.vehiclePlate) {
            await getCarInfoByPlateNumber(this.selectedTagForm.vehiclePlate).then(res => {
              console.log(res, '====res===');
              if (res.code === 200) {
                const driverInfo = res.data;
                this.vehicleInformation = {
                  driverDocument: driverInfo.vehicleOwnerCNPJ ? driverInfo.vehicleOwnerCNPJ : driverInfo.vehicleOwnerCPF,
                  licensePlateNumber: driverInfo.vehicleLicensePlate,
                  TrailerRENAVAM: driverInfo.vehicleDocumentation,
                  TrailerTare: driverInfo.vehicleTareWeight,
                  TrailerCapacity: driverInfo.vehicleCapacityKg,
                  TrailerRNTRC: driverInfo.vehicleRNTRC,
                  TrailerDocuments: driverInfo.vehicleDocumentation,
                  ie: driverInfo.ie,
                  State: driverInfo.vehicleState,
                  WheelKind: driverInfo.vehicleWheelsetType,
                  vehicleType: driverInfo.vehicleTypeOwnership
                };
              } else {
                isPlateNumber = false;
              }
            }).catch(err => {
              console.log(err, '====err===');
              isPlateNumber = false;
            });
          }
          console.log(isPlateNumber, '=isPlateNumber');
          if (isPlateNumber === false) {
            return;
          }
          const driver = this.driverList.filter(item => this.selectedTagForm.selectedDriver === item.id);
          const addDriver = {
            id: driver[0].id,
            name: driver[0].driverName,
            cpf: driver[0].driverDocument
          };
          this.selectedTagForm.selectedDriverItem.push(addDriver);
          this.selectedTagFormKey = new Date().getTime();
          this.selectedTagForm.vehiclePlate = null;
          this.selectedTagForm.selectedDriver = null;
          this.$nextTick(() => {
            this.$refs.step3.clearValidate();
          });
        }
      });
    },
    // 删除全部司机
    deleteAllDriver() {
      this.selectedTagForm.selectedDriverItem = [];
    },
    // 删除已选中的司机
    deleteDriver(index) {
      this.selectedTagForm.selectedDriverItem.splice(index, 1);
    },
    // 添加拖车
    addVeicReboque() {
      if (this.selectedTagForm.veicReboque) {
        getCarInfoByPlateNumber(this.selectedTagForm.veicReboque).then(res => {
          if (!res.data) {
            this.$message.error(this.$t('mdfeTranslate.PlateNumberDoesNotExist')); // '车牌号不存在'
          } else {
            let isAdd = true;
            this.veicReboqueList.map(item => {
              if (item.licensePlateNumber === this.selectedTagForm.veicReboque) {
                isAdd = false;
              }
            });
            if (!isAdd) {
              this.$message.error(this.$t('mdfeTranslate.PlateNumberCannotBeRepeated'));
              return;
            }
            const item = {
              providerName: res.data.providerName,
              driverDocument: res.data.vehicleOwnerCNPJ ? res.data.vehicleOwnerCNPJ : res.data.vehicleOwnerCPF,
              licensePlateNumber: res.data.vehicleLicensePlate,
              TrailerRENAVAM: res.data.vehicleDocumentation,
              TrailerTare: res.data.vehicleTareWeight,
              TrailerCapacity: res.data.vehicleCapacityKg,
              TrailerRNTRC: res.data.vehicleRNTRC,
              TrailerDocuments: res.data.vehicleDocumentation,
              ie: res.data.ie,
              State: res.data.vehicleState,
              WheelKind: res.data.vehicleWheelsetType,
              vehicleType: res.data.vehicleTypeOwnership
            };
            this.veicReboqueList.push(item);
            this.selectedTagForm.veicReboque = null;
          }
        });
      }
    },
    getColSpan(index, length) {
      // 如果只有一个元素，占满整行
      if (length === 1) {
        return 'full-width';
      }
      // 如果是最后一个元素且总数为奇数，则占满整行
      if (index === length - 1 && length % 2 === 1) {
        return 'full-width';
      }
      // 其他情况各占一半
      return 'half-width';
    },
    // 删除拖车
    deleteVeicReboque(index) {
      this.veicReboqueList.splice(index, 1);
    },
    // 确认处理异常
    submitAbnormal() {
      if (!this.mdfeKey) {
        this.$message.error(this.$t('mdfeTranslate.PleaseEnterAbnormalMDFE'));
        return;
      }
      if (this.selectedTagForm.selectedDriverItem.length === 0) {
        this.$message.error(this.$t('mdfeTranslate.PleaseAddDriverAndVehicle'));
        return;
      }
      const data = {
        mdfeKey: this.mdfeKey,
        driver: this.selectedTagForm.selectedDriverItem,
        vehiclePlate: this.vehicleInformation.licensePlateNumber,
        veicReboque: this.veicReboqueList.map(item => item.licensePlateNumber)
      };
      this.$confirm(this.$t('mdfeTranslate.PleaseConfirmWhetherOperation'), this.$t('mdfeTranslate.AbnormalMdfeProcessing'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定',
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消',
        type: 'warning'
      }).then(() => {
        console.log(data, '===data');
        handleMdfeException(data).then(res => {
          if (res.code === 200) {
            if (res.data.success) {
              this.$message.success(this.$t('operationCenter.TheOperationSucceeded'));
              this.$emit('updateTable');
            } else {
              this.$message.error(res.data.failureReason);
            }
          }
        });
      });
    }
  }
};
</script>

<style>
.driver-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  height: 300px;
  overflow-y: auto;
}

.driver-item {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
}

.driver-item.full-width {
  flex: 1 1 100%;
}

.driver-item.half-width {
  flex: 1 1 calc(50% - 5px);
}
.mdfeFormCard .el-card__header {
  padding: 10px;
  background: #f1f1f1;
  color: #000;
}
</style>
